import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { RegionEffects } from './regions/regions.effects';
import { RegionNamespace, RegionReducer } from './regions/regions.store';
import {
  CountryDataNamespace,
  CountryDataReducer,
  countryStoreConfigFactory,
  COUNTRY_STORE_CONFIG,
} from './store/country.store';

@NgModule({
  imports: [
    StoreModule.forFeature(RegionNamespace, RegionReducer),
    StoreModule.forFeature(CountryDataNamespace, CountryDataReducer, COUNTRY_STORE_CONFIG),
  ],
  providers: [
    RegionEffects,
    {
      provide: COUNTRY_STORE_CONFIG,
      useFactory: countryStoreConfigFactory,
    },
  ],
})
export class CountryDataModule {}
